import { css } from "@microsoft/fast-element";
import { fillColor, getToken, neutralForegroundRest } from "../../design-tokens";

export const backgroundStyles = css`
    :host {
        background-color: ${fillColor};
        color: ${neutralForegroundRest};
    }
`;

export const fontStyles = css`
    :host {
        font-family: ${getToken('typography-font-family')};
        font-size: ${getToken('typography-body-font-size')};
        line-height: ${getToken('typography-body-line-height')};
    }
`;
